import clsx from 'clsx';
import styles from './Spinner.module.scss';

export interface SpinnerProps {
  /** `sm` acompanha uma linha de texto; `md` é o estado de carregamento da página. */
  size?: 'sm' | 'md';
  className?: string;
}

export const Spinner = ({ size = 'sm', className }: SpinnerProps) => (
  <span className={clsx(styles.spinner, styles[size], className)} aria-hidden="true" />
);

export default Spinner;
